import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { catchError, tap, finalize } from "rxjs/operators";
import { throwError } from "rxjs";
import { LoginService } from "../../services/login.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})

export class LoginComponent implements OnInit {
  msg = "";
  loginForm: FormGroup;
  processingLoginRequest: boolean = false;
  constructor(
    private loginService: LoginService,
    private fb: FormBuilder,
    private routes: Router,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService
  ) {}
  check(uname: string, p: string) {
    // if (!this.loginForm.valid) {
    //   return;
    // }
    const email = uname;
    const pwd = p;
    // this.showInvalid = false;
    this.loginService
      .login(email, pwd)
      .pipe(
        catchError((err) => {
          this.toastr.error(
            "Email or password are incorrect. ",
            "Validation failed!",
            {
              timeOut: 3000,
              positionClass: "toast-top-left",
            }
          );
          return throwError(err);
        }),
        tap((res) => {
          if (res.data.result == "ok") {
            localStorage.clear();
            const now = new Date();
            const sessionId = res.data.token;
            const item = {
              value: sessionId,
              expiry: now.getTime() + 1.2e6,
            };
            localStorage.setItem("Token", JSON.stringify(item));
            this.routes.navigate(["/components"]);
          } else {
            this.toastr.error(
              "An error occured while processing your request. Try again later.",
              "Error!",
              {
                timeOut: 2000,
                positionClass: "toast-top-left",
              }
            );
          }
          this.cdr.markForCheck();
        }),
        finalize(() => {
          this.cdr.markForCheck();
        })
      )
      .subscribe();
  }

  ngOnInit() {
    this.loginService.logOut(true);
    console.log("here");
    this.loginForm = this.fb.group({
      username: ["", [Validators.required]],
      password: ["", [Validators.required]],
    });
  }
  /*  login Form */

}
